"use client";

import React, { useState, useRef } from "react";
import Image from "next/image";
import "./VisionAccordion.css";

export default function VisionAccordion() {
  const [activeIndex, setActiveIndex] = useState(0);

  // create refs array
  const contentRefs = useRef([]);

  const asked_questions = [
    {
      question: "Vision",
      answer:
        "To redefine urban living by creating spaces that go beyond walls — where people, design, and purpose come together to build enduring communities.",
    },
    {
      question: "Mission",
      answer:
        "To deliver thoughtfully designed, quality-driven developments that integrate architecture, sustainability, and human experience — ensuring every NB project stands for trust, timelessness, and transformation.",
    },
    {
      question: "Manifesto",
      answer:
        "At NB Group, we believe that a space is more than what it contains — it's what it inspires. For over a decade, our foundation has been trust; our material, purpose. Every project we create is designed not just to stand tall, but to stand for something — connection, comfort, and care. We build thoughtfully, where architecture meets emotion and design meets detail. Our commitment to quality and sustainability is not just a promise — it's our philosophy. Because for us, real estate isn't only about constructing walls and towers — it's about shaping the way people live, work, and belong.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="main-container">
      <div className="section-padding">
        <div className="two-grid inner-flex-big inner-flex-tab">
          {/* Image Section */}
          <div className="relative" style={{ aspectRatio: "500 / 500" }}>
            <Image src="/images/about/vision-misson.jpeg" alt="values" fill />
          </div>

          {/* Accordion Section */}
          <div className="frequently-accordion">
            <div className="inner-flex" style={{ gap: 0 }}>
              {asked_questions.map((data, index) => {
                const isActive = activeIndex === index;

                return (
                  <div key={index} className="accordian-title accordion-block">
                    {/* Title */}
                    <div
                      className={`flex-row j-c-sb alc w100 accordion_click accordion_click_relative ${
                        isActive ? "active" : ""
                      }`}
                      onClick={() => toggleAccordion(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="w100 section-subtitle">
                        <h4 className="bold-fonts uppercase">
                          {data.question}
                        </h4>
                      </div>
                    </div>

                    {/* Content */}
                    <div
                      ref={(el) => (contentRefs.current[index] = el)}
                      className="content_accordian section-content accordion-dec-padding w100"
                      style={{
                        display: "block",
                        maxHeight: isActive
                          ? `${contentRefs.current[index]?.scrollHeight}px`
                          : "0px",
                        overflow: "hidden",
                        transition: "max-height 0.4s ease",
                      }}
                    >
                      <p>{data.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
